<template>
  <div class="ad-tips-panel">
    <div class="panel-header">
      <span class="panel-title">进阶赋能型智能广告系列</span>
      <el-switch
        :value="enabled"
        disabled
      ></el-switch>
    </div>
    <div class="panel-content">
      <div class="tip-item">
        <div
          class="tip-icon"
          :class="isAdvancedBudget ? 'precision' : 'disabled'"
        >
          <span
            v-if="!isAdvancedBudget"
            class="cross-icon"
            >×</span
          >
        </div>
        <div class="tip-info">
          <div class="tip-title">预算</div>
          <div class="tip-desc">正在使用广告系列预算（或者只有一个广告组）。</div>
        </div>
      </div>
      <div class="tip-item">
        <div
          class="tip-icon"
          :class="isAdvancedAudience ? 'coverage' : 'disabled'"
        >
          <span
            v-if="!isAdvancedAudience"
            class="cross-icon"
            >×</span
          >
        </div>
        <div class="tip-info">
          <div class="tip-title">受众</div>
          <div class="tip-desc">至少在一个广告组中使用了进阶赋能型受众。</div>
        </div>
      </div>
      <div class="tip-item">
        <div
          class="tip-icon"
          :class="isAdvancedPlacement ? 'optimize' : 'disabled'"
        >
          <span
            v-if="!isAdvancedPlacement"
            class="cross-icon"
            >×</span
          >
        </div>
        <div class="tip-info">
          <div class="tip-title">版位</div>
          <div class="tip-desc">将为所有的广告都使用进阶版位。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdTipsPanel',
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
    isAdvancedBudget: {
      type: Boolean,
      default: false,
    },
    isAdvancedPlacement: {
      type: Boolean,
      default: false,
    },
    isAdvancedAudience: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.ad-tips-panel {
  width: 100%;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 16px;
  margin-bottom: 16px;

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #ebeef5;

    .panel-title {
      font-size: 14px;
      font-weight: 600;
      color: #303133;
    }
  }

  .panel-content {
    .tip-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .tip-icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 12px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        &.precision {
          background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
        }

        &.coverage {
          background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
        }

        &.optimize {
          background: linear-gradient(135deg, #e6a23c 0%, #ebb563 100%);
        }

        &.disabled {
          background: #c0c4cc;
        }

        .cross-icon {
          color: #fff;
          font-size: 14px;
          font-weight: bold;
          line-height: 1;
        }
      }

      .tip-info {
        flex: 1;

        .tip-title {
          font-size: 14px;
          font-weight: 500;
          color: #303133;
          margin-bottom: 4px;
        }

        .tip-desc {
          font-size: 12px;
          color: #909399;
          line-height: 1.5;
        }
      }
    }
  }
}
</style>
